import { useCompany } from "@/libs/hooks/useCompany";
import { useNow } from "@/libs/hooks/useNow";
import { FC, useState, useMemo } from "react";
import { useRouter } from "next/router";
import { Loader } from "@moneyforward/mfx_biz_react_components";
import { MainTemplate } from "@/components/templates";
import { PlanCancel, PlanStopCancel } from "@/components/organisms";
import { ErrorCode, moveToErrorPage } from "@/libs/errors";
import paths from "@/libs/paths";

type Props = {};

export const PlanCancelPage: FC<Props> = () => {
  const router = useRouter();

  const [isCancelPage, setIsCancelPage] = useState<boolean>(false);

  // data loaders
  const { now, nowLoading } = useNow();
  const { company, companyLoading, isAdmin } = useCompany();

  // handlers
  const handleClickCancelPlanCancel = async () => {
    await router.replace(paths.ContractManagement);
  };

  const handleClickCancelPlanStopCancel = async () => {
    await router.replace(paths.ContractManagement);
  };

  // loading conditional rendering
  const isLoading = useMemo(() => {
    return nowLoading || companyLoading || !router.isReady;
  }, [nowLoading, companyLoading, router.isReady]);

  if (isLoading) {
    return <Loader>Loading...</Loader>;
  }

  if (!isAdmin) {
    moveToErrorPage(ErrorCode.ONLY_ADMINISTRATOR_CAN_OPERATE_IT);
    return null;
  }

  return (
    <MainTemplate>
      {company.planContract ? (
        <PlanCancel
          now={now}
          company={company}
          onClickCancel={handleClickCancelPlanCancel}
        />
      ) : (
        <PlanStopCancel
          company={company}
          setIsCanecelPage={setIsCancelPage}
          now={now}
          onClickCancel={handleClickCancelPlanStopCancel}
        />
      )}
    </MainTemplate>
  );
};
